module.exports = __webpack_public_path__ + "img/map_search_info_icon03.3a9cad54.svg";